import React from 'react'
import './App.css';
import { Link, animateScroll as scroll } from 'react-scroll';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


export const Header = () => {
    const scrollToTop = () => {
        scroll.scrollToTop();
      };
  return (
    <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand ms-lg-4 fs-4 fw-bolder my-2 fontcolour" href="#">McLaren</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav ms-auto m  ">
        <li class="nav-item ms-lg-5 ">
            <a class="nav-link fs-5 mx-auto" aria-current="page" href="#kilometer">Home</a>
        </li>
        <li class="nav-item ms-lg-5">
           <Link to="section1" smooth={true} duration={500}><a class="nav-link fs-5" href="#">Kilometer</a></Link>
        </li>
        <li class="nav-item ms-lg-5">
            <Link to="section2" smooth={true} duration={500}>  <a class="nav-link fs-5" href="#">Fuel</a></Link>
       </li>
        <li class="nav-item ms-lg-5">
            <Link to="section3" smooth={true} duration={500}>  <a class="nav-link fs-5" href="#">Mileage</a></Link>
        </li>
        <li class="nav-item ms-lg-5 ">
            <Link to="section4" smooth={true} duration={500}> <a class="nav-link fs-5" href="#">Speed</a></Link>
        </li>
        <li class="nav-item ms-lg-5 ">
            <Link to="section5" smooth={true} duration={500}> <a class="nav-link fs-5" href="#">Rpm</a></Link>
        </li>
        <li class="nav-item ms-lg-5 me-lg-4">
            <Link to="section6" smooth={true} duration={500}> <a class="nav-link fs-5" href="#">Torque</a></Link>
        </li>
        
      </ul>
        
      
    </div>
  </div>
</nav>
<div id='kilometer'>
  <img src={require('./mcl.png')} className='banner img-fluid' alt="" />
</div>
    </div>
  
  )
}
